export default function () {
  $('#navbarToggler').hide();
}
